import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchTemplates: (page = 1) => {
    return {
      url: `fedwire_templates/?page=${page}`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },

  deleteTemplate: (fedwireTemplateId: API.FedwireTemplateId) => {
    return {
      url: `fedwire_templates/${fedwireTemplateId}/`,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    } satisfies NetworkPayload;
  },
};
